import ApiClient from 'api/ApiClient'

class SaleRoofTypesApi extends ApiClient {
  constructor() {
    super({url:'sale_roof_types'})
  }
}

export default SaleRoofTypesApi
